import * as React from 'react';

import * as styles from './Anonymous.css';

export const Anonymous = ({ children }: React.PropsWithChildren<{}>): React.JSX.Element => {
  return <div className={styles['container']}>{children}</div>;
};
